import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiTopNavigationComponent } from '@components/ui-top-navigation/ui-top-navigation.component';
import { TranslateModule } from '@ngx-translate/core';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        ComponentSharedModule,
        TranslateModule,
        MatIconModule,
        UiNgLetModule,
        MatTooltipModule,
    ],
    declarations: [
        UiTopNavigationComponent,
    ],
    exports: [
        UiTopNavigationComponent,
    ],
})
export class UiTopNavigationModule { }
